/**
 * @file 채널 폴더 선택값 ↔ API 파라미터 변환.
 *
 * <p>폴더 선택 UI(사이드바)와 조회 범위를 쓰는 쪽(피드·일정·업무·파일 탭)이 서로 다른 컴포넌트라,
 * 그 사이 규약을 이 파일 하나에 둔다. 예전엔 칩 줄 컴포넌트에 같이 들어 있었는데
 * 폴더가 사이드바로 옮겨지면서 UI 없이 규약만 필요해져 분리했다.
 *
 * <p>서버는 파라미터 두 개로 세 가지 보기를 구분한다 —
 * 전체(둘 다 없음) / 특정 폴더({@code folderId}) / 미분류({@code onlyUnfiled=true}).
 * "폴더 지정 없음(전체)" 과 "폴더가 빈 것만(미분류)" 은 뜻이 정반대인데 folderId 하나로는
 * 둘 다 빈 값이 되어 구분할 수 없어서다.
 */

/** 전체 보기. */
export const ALL = null;

/** 미분류(폴더 미지정)만 보기. */
export const UNFILED = "UNFILED";

/** 선택값 → API 파라미터(channelApi 의 folderScope 규약). */
export function toFolderScope(selected) {
    if (selected === UNFILED) return { onlyUnfiled: true };
    if (selected == null) return {};
    return { folderId: selected };
}

/**
 * 선택값이 실제 폴더 id 인지(전체·미분류가 아닌지).
 *
 * <p>새 글·일정·업무의 <b>기본 폴더</b>로 쓸 값을 뽑는 데 사용한다 —
 * '전체'·'미분류' 를 보고 있으면 null(미분류로 등록)이 된다.
 */
export function selectedFolderId(selected) {
    return selected === UNFILED || selected == null ? null : selected;
}
